/** Larger labels for tag filter chips on admin puzzle boards (paired with Autocomplete size="small") */
export const adminTagFilterChipSx = {
    height: "auto",
    py: 0.4,
    "& .MuiChip-label": {
        fontSize: "1rem",
        lineHeight: 1.25,
        px: 1.125,
    },
};

/** Dropdown option rows — similar density to small Select MenuItem */
export const adminTagFilterAutocompleteSlotProps = {
    listbox: {
        sx: {
            "& .MuiAutocomplete-option": {
                minHeight: 36,
                py: 0.5,
                fontSize: "0.875rem",
            },
        },
    },
};

/**
 * Keep matching suggestions, and allow a tag that is not in the list (type + Enter / click).
 * @param {function(any): string} getValue
 * @param {string[]} [selectedValues]
 */
export function filterAdminTagOptions(options, params, getValue, selectedValues = []) {
    const list = Array.isArray(options) ? options : [];
    const input = typeof params?.inputValue === "string" ? params.inputValue.trim() : "";
    const q = input.toLowerCase();
    const filtered = !q
        ? list.slice()
        : list.filter((opt) => String(getValue(opt) || "").toLowerCase().includes(q));
    if (input) {
        const exists =
            list.some((opt) => String(getValue(opt) || "").trim().toLowerCase() === q)
            || selectedValues.some((s) => String(s || "").trim().toLowerCase() === q);
        if (!exists) {
            filtered.push(input);
        }
    }
    return filtered;
}
